import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export const MICK_CAD_DXF_EMAIL = 'contact@designbuilder.co.il';

type Props = {
  open: boolean;
  onClose: () => void;
};

const CadToDxfHelpDialog = ({ open, onClose }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[1400] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cad-dxf-dialog-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/50"
        aria-label="close"
        onClick={onClose}
      />
      <div className="relative w-full max-w-[520px] rounded-lg bg-white px-6 py-10 text-center shadow-xl">
        <button
          type="button"
          onClick={onClose}
          aria-label="close"
          className="absolute end-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded text-2xl leading-none text-gray-500 hover:bg-gray-100"
        >
          ×
        </button>
        <h2 id="cad-dxf-dialog-title" className="m-0 text-2xl font-bold text-[#2F3B49]">
          {t('REVISION_V4_CAD_DXF_TITLE')}
        </h2>
        <p className="mb-0 mt-4 text-lg leading-relaxed text-[#2F3B49]">
          {t('REVISION_V4_CAD_DXF_BODY')}
        </p>
        <p className="mb-0 mt-2 text-lg leading-relaxed text-[#2F3B49]">
          {t('REVISION_V4_CAD_DXF_BODY_2')}
        </p>
        <p className="mb-0 mt-4 text-lg leading-relaxed">
          <a
            href={`mailto:${MICK_CAD_DXF_EMAIL}`}
            className="text-[#0E66F0] underline"
          >
            {MICK_CAD_DXF_EMAIL}
          </a>
        </p>
      </div>
    </div>,
    document.body
  );
};

export default CadToDxfHelpDialog;
